export const HistoricReleaseConfig = {
  getAll: '/snapshot/v1/historicReleases?datasetId={:datasetId}',
  getAllRepresentative:
    '/snapshot/historicReleasesRepresentative?dataflowId={:dataflowId}&representativeId={:representativeId}'
};
